export default {
  bannerText: `The Unitary Foundation 2025 Quantum Open Source Software Survey is now open. Share your voice before it closes on October 3, 2025! [Take the survey!](https://unitary.foundation/posts/2025_qoss_survey/)`,
}
